//angular imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

//local imports
import { AbstractRoomContentModel } from '@app/catalog-common';
/**
 * @summary  Controls how department item is shown
 */
export enum RoomContentDisplayMode
{
    
    /**
     * @summary  Show name + code
     */
    FullName = 0,


        /**
     * @summary  The name only
     */
    Name = 0,

    /**
     * @summary  The code only
     */    
    Code = 1,
}

@Component({
  selector: 'room-content-item',
  templateUrl: './room-content-item.component.html',
  styleUrl: './room-content-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RoomContentItemComponent {

  DisplayMode: typeof RoomContentDisplayMode = RoomContentDisplayMode;
  public roomContent = input.required<AbstractRoomContentModel>();
  public displayMode = input<RoomContentDisplayMode>(RoomContentDisplayMode.FullName);
  
}
